import React from "react";
import "./CommonsStyles.css";

const UserProfile = () => {
  return (
    <button onClick={() => console.log("userName")} className="honorairesBtn">
      <img src="./assets/avatar.png" alt="" className="profileImg" />
    </button>
  );
};

export default UserProfile;
